export const SET_CSM_FOCUS_DATA = "SET_CSM_FOCUS_DATA";

const initialState = {
  isDataLoading: true,
  priorityTasks: [],
  upcomingTasks: [],
  totalItems: 0,
  overdueTasks: [],
  plannedTasks: [],
  completedTasks: [],
  completePercentage: 0,
};

export default (state = initialState, action = {}) => {
  if (action.type === SET_CSM_FOCUS_DATA) {
    return { ...state, ...action.payload };
  }

  return state;
};
